import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import "./styles.css";

const TotalValueCard: React.FC<{ totalValue: string }> = ({ totalValue }) => {

  const accessibility = useAccessibility();

  return (
    <div className="registration-data-card-holder">
      <div className="registration-data-card" style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
        <div className={'registration-data-row'}>
          <span style={accessibility.textStyleAccessibility} className="registration-data-key">Valor total</span>
          <span style={accessibility.textStyleAccessibility} className="registration-data-value">{totalValue}</span>
        </div>
      </div>
    </div>
  )
}

export default TotalValueCard;